import { httpRequest } from './_http.api.service.js';

const paymentRequestOptions = { rawResponse: true, statusCode: {} };

export function cancelSubscription() {
	return httpRequest('post', 'cancel_subscription', undefined, paymentRequestOptions);
}

export function subscribeWithPayment(method, payload, productID, quantity) {
	return httpRequest('post', 'subscribe_payment', undefined, {
		...paymentRequestOptions,
		data: { payload: payload, productid: productID, method: method, quantity: quantity }
	});
}

export function getPaymentData() {
	return httpRequest('get', 'payment_data', undefined, paymentRequestOptions).then(function (response) {
		if (response.status == 401) {
			window.location.reload();
			throw response;
		}
		return response;
	});
}

export function getBraintreeClientToken() {
	return httpRequest('get', 'payment_clienttoken', undefined, {
		...paymentRequestOptions,
		dataType: 'text'
	});
}
